import { render, staticRenderFns } from "./CommunicationProtocols.vue?vue&type=template&id=7d978c00&"
import script from "./CommunicationProtocols.vue?vue&type=script&lang=js&"
export * from "./CommunicationProtocols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports